import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
            Ready To Discover Better Sugargoo Finds?
          </h2>
          <p className="text-background-300 text-sm md:text-base max-w-xl mx-auto mb-8">
            Start exploring thousands of curated products, verified finds, and expert shopping resources on the main Sugargoo Spreadsheet platform.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-colors no-underline cursor-pointer whitespace-nowrap"
            >
              Visit Our Main Website
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <Link
              to="/sugargoo-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/10 border border-background-300/30 text-background-50 text-base font-semibold hover:bg-background-50/15 transition-colors no-underline cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              Read Our Guide
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 py-8 border-t border-background-800 mb-8">
          <div>
            <h4 className="text-sm font-semibold text-background-300 mb-3">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">Home</Link></li>
              <li><Link to="/sugargoo-spreadsheet-guide" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">Complete Guide</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">Main Website</a></li>
            </ul>
          </div>
          <div className="col-span-2 lg:col-span-2">
            <h4 className="text-sm font-semibold text-background-300 mb-3">SEO Guides</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {articles.slice(0, 8).map((a) => (
                <li key={a.slug}>
                  <Link to={`/article/${a.slug}`} className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline truncate block">
                    {a.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-300 mb-3">More Resources</h4>
            <ul className="space-y-2">
              <li><Link to="/article/sugargoo-review-2026" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">Sugargoo Review 2026</Link></li>
              <li><Link to="/article/is-sugargoo-legit" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">Is Sugargoo Legit</Link></li>
              <li><Link to="/article/sugargoo-shipping-guide" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">Shipping Guide</Link></li>
              <li><Link to="/article/sugargoo-vs-pandabuy" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">Sugargoo vs PandaBuy</Link></li>
            </ul>
          </div>
          <div className="col-span-2 sm:col-span-1">
            <h4 className="text-sm font-semibold text-background-300 mb-3">Disclaimer</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              This website provides educational information only. We do not sell products or process payments. Users should verify all sellers and transactions independently.
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="font-heading text-lg font-semibold text-background-200">
              Sugargoo <span className="text-primary-400">Spreadsheet</span> Hub
            </span>
          </div>
          <p className="text-center text-xs text-background-600">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet Hub. All rights reserved. Independent educational resource.
          </p>
        </div>
      </div>
    </footer>
  );
}